module.exports = __webpack_public_path__ + "img/np_ondemandtraining_2946579_000000.6badb4b6.svg";